module.exports = __webpack_public_path__ + "dc0f4cbac19ee19629cab59208c1686f.png";